
<template>
  <div>
    <div class="title">基础信息</div>
    <el-form size="small" :model="ruleForm" ref="ruleForm" :rules="ruleForm.status==1?rules:rules2" label-position="top" :validate-on-rule-change="false">
      <div class="block-main">
        <el-form-item label="框架协议名称" prop="name" class="block-form-item w-25">
            <el-input v-model="ruleForm.name" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName" class="block-form-item w-25">
          <el-input v-model="ruleForm.customerName">
			  <i slot="append" @click="khListModal = true" class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
		  </el-input>
        </el-form-item>
        <el-form-item label="客户类型" prop="customerType" class="block-form-item w-25 select-input-wrap-s">
          <el-select v-model="ruleForm.customerType"  class="w-100">
               <el-option v-for="(item,index) in khType" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌资源" prop="brandResource" class="block-form-item w-25 select-input-wrap-s">
          <el-input v-model="ruleForm.brandResource" maxlength="50" ></el-input>
        </el-form-item>
        <el-form-item label="合同状态" prop="status" class="block-form-item w-25 select-input-wrap-s">
          <el-select v-model="ruleForm.status" class="w-100"  >
               <el-option v-for="(item,index) in htType" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有花果对接负责人" prop="principalName" class="block-form-item w-25">
            <el-input v-model="ruleForm.principalName" >
				<i slot="append"  @click="adminListModal = true" class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
			</el-input>
        </el-form-item>
        <el-form-item label="合同开始时间" prop="beginTime" class="block-form-item w-25">
          <el-date-picker value-format='yyyy-MM-dd HH:mm:ss' :picker-options="pickerOptionsStart"  v-model="ruleForm.beginTime" type="date" class="w-100">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" prop="endTime" class="block-form-item w-25">
          <el-date-picker  value-format='yyyy-MM-dd HH:mm:ss' :picker-options="pickerOptionsEnd" v-model="ruleForm.endTime" type="date" class="w-100">
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="center_Box">
        <div class="title">商务信息</div>
		<el-form-item label="框架协议政策" prop="policy" class="block-form-item w-99">
		    <el-input type="textarea" rows="3" maxlength="1000" show-word-limit v-model="ruleForm.policy"></el-input>
		</el-form-item>
		<el-form-item label="付款条款" prop="paymentClause" class="block-form-item w-99">
		    <el-input type="textarea" rows="3" maxlength="1000" show-word-limit  v-model="ruleForm.paymentClause"></el-input>
		</el-form-item>
		<el-form-item label="补充协议条款" prop="supplementalAgreementClause" class="block-form-item w-99">
		    <el-input type="textarea" rows="3" maxlength="1000" show-word-limit  v-model="ruleForm.supplementalAgreementClause"></el-input>
		</el-form-item>
	   <el-form-item label="上传补充协议附件" class="block-form-item w-25">
			<el-upload  multiple :on-preview="handlePreview" :on-remove="handleRemove1" :file-list="fileList1"  class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="beforeUpload">
				<el-button  size="small" type="primary">上传补充协议附件</el-button>
			</el-upload>
		</el-form-item>
      </div>
	  <!-- 合作信息 -->
		<div class="center_Box">
			  <div class="title">合作信息</div>
			<el-form-item label="关联商务合同" prop="notPassReason" class="block-form-item w-99">
				<el-input v-model="contractName" disabled>
					<i slot="append"  @click="mediaListModal = true" class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				</el-input>
			</el-form-item>
			  <el-form-item  class="block-form-item w-25">
				  <div style="display: flex;justify-content: start;">
					 <span slot="label">框架累计金额</span>
					 <el-tooltip class="item" style="margin: auto 0;margin-left: 5px;" effect="dark" content="关联商务合同的合同金额总和" placement="right-end">
							<i class="el-icon-question"></i>
					 </el-tooltip> 
				  </div>
				  <el-input v-model="ruleForm.money" disabled></el-input>
			  </el-form-item>
			  <el-form-item  class="block-form-item w-25">
				  <div style="display: flex;justify-content: start;">
						 <span slot="label">框架累计合作次数</span>
						 <el-tooltip class="item" style="margin: auto 0;margin-left: 5px;" effect="dark" content="关联商务合同下投放记录总数" placement="right-end">
								<i class="el-icon-question"></i>
						 </el-tooltip>
				  </div>
				  <el-input v-model="ruleForm.count" disabled></el-input>
			  </el-form-item>
			  <el-form-item  prop="notPassReason" class="block-form-item w-99">
				  <div style="display: flex;justify-content: start;">
						 <span slot="label">涵盖博主账号</span>
						 <el-tooltip class="item" style="margin: auto 0;margin-left: 5px;" effect="dark" content="关联商务合同的博主账号去重汇总" placement="right-end">
								<i class="el-icon-question"></i>
						 </el-tooltip>
				  </div>
			  	<el-input v-model="accountName" disabled></el-input>
			  </el-form-item>
			</div>
		<!-- 盖章信息 -->
		  <div class="title">盖章信息</div>
		  <div class="block-main">
			<el-form-item label="框架协议文件"  class="block-form-item w-25">
				<el-upload  multiple :on-preview="handlePreview" :on-remove="handleRemove2" :file-list="fileList2"  class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="beforeUpload2">
					<el-button  size="small" type="primary">上传框架协议文件</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item label="盖章类型" prop="sealType" class="block-form-item w-25 select-input-wrap-s">
			  <el-select v-model="ruleForm.sealType" class="w-100" >
				   <el-option v-for="(item,index) in sealType" :label="item.label" :value="item.value"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="盖章经办人" prop="sealOperatorName" class="block-form-item w-25 select-input-wrap-s">
			  <el-input v-model="ruleForm.sealOperatorName" >
				  <i slot="append" @click="$refs.sealp.adminListModal=true"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
			  </el-input>
			</el-form-item>
			<el-form-item label="盖章状态" prop="money" class="block-form-item w-25">
			  <el-select v-model="ruleForm.sealStatus" class="w-100" disabled >
			  		<el-option v-for="(item,index) in sealStatus" :label="item.label" :value="item.value"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="盖章申请人" prop="sealApplyUserName" class="block-form-item w-25">
				<el-input v-model="ruleForm.sealApplyUserName" disabled>
					<!-- <i slot="append"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i> -->
				</el-input>
			</el-form-item>
			<el-form-item label="盖章申请时间" prop="sealApplyTime" class="block-form-item w-25">
			  <el-date-picker disabled v-model="ruleForm.sealApplyTime" type="date" class="w-100">
			  </el-date-picker>
			</el-form-item>
			<el-form-item label="盖章人" prop="sealUserName" class="block-form-item w-25 select-input-wrap-s">
			  <el-input v-model="ruleForm.sealUserName" disabled></el-input>
			</el-form-item>
			<el-form-item label="盖章时间" prop="sealTime" class="block-form-item w-25 select-input-wrap-s">
				<el-date-picker disabled v-model="ruleForm.sealTime" type="date" class="w-100">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="框架协议扫描件"  class="block-form-item w-25">
				<el-upload  multiple :on-preview="handlePreview" :on-remove="handleRemove3" :file-list="fileList3"  class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="beforeUpload3">
					<el-button  size="small" type="primary">上传扫描件</el-button>
				</el-upload>
			</el-form-item>
		</div>
		<!-- 其他信息 -->
		<div class="title">其他信息</div>
			<el-form-item label="框架协议创建人" prop="createUserName" class="block-form-item w-25 select-input-wrap-s">
			  <el-input v-model="ruleForm.createUserName" disabled></el-input>
			</el-form-item>
			<el-form-item label="创建时间" prop="createTime" class="block-form-item w-25 select-input-wrap-s">
			  <el-date-picker disabled v-model="ruleForm.createTime" type="date" class="w-100">
			  </el-date-picker>
			</el-form-item>
			<el-form-item label="最新修改人" prop="updateUserName" class="block-form-item w-25 select-input-wrap-s">
			  <el-input v-model="ruleForm.updateUserName" disabled></el-input>
			</el-form-item>
			<el-form-item label="最新修改时间" prop="updateTime" class="block-form-item w-25 select-input-wrap-s">
			  <el-date-picker disabled v-model="ruleForm.updateTime" type="date" class="w-100">
			  </el-date-picker>
			</el-form-item>
    </el-form>
    <div style="text-align:center;margin-top: 50px;">
      <!-- <el-button style="width:120px;margin-right:60px;" plain>取 消</el-button> -->
      <el-button style="width:120px;" @click="saveClick('ruleForm')" type="primary">提 交</el-button>
    </div>
	<!-- 盖章经办人弹框 -->
	<sealPeople ref="sealp" @select="selectPeople"></sealPeople>
	<!-- 有花果对接负责人弹框 -->
	<el-dialog title="选择有花果负责人" :visible.sync="adminListModal" width="1000px" class="yhg-dialog" @open="openAdminSelectModal">
	  <div class="select-con single">
	    <span class="label">已选人员：</span>
	    <div class="content" v-if="selectAdmin">
	      <el-tag class="select-tag" closable :type="selectAdmin.username" effect="dark" @close="onAdminTagClose">
	        <span class="select-tag-text">{{ selectAdmin.username }}</span>
	      </el-tag>
	    </div>
	  </div>
	  <div class="filter-con">
	    <span class="label">用户搜索：</span>
	    <el-input size="small" v-model="adminForm.queryString" placeholder="用户名/手机号" @keyup.enter.native="onAdminSearch"></el-input>
	    <el-button class="search-btn" size="small" type="primary" @click="onAdminSearch">搜索</el-button>
	  </div>
	  <div class="table-con">
	    <el-table :data="adminTable" v-loading="adminTableLoading" size="mini" ref="adminSelectTable">
	      <el-table-column label="选择" width="55" align="center">
	        <template slot-scope="scope">
	          <span class="hide-label-radio">
	            <el-radio v-model="selectAdminId" @change="onChangeAdmin" :label="scope.row.id"></el-radio>
	          </span>
	        </template>
	      </el-table-column>
	      <el-table-column label="用户名" prop="username" align="center"></el-table-column>
	      <el-table-column label="角色" prop="roleNameList" align="center">
	        <template slot-scope="scope">
	          <div v-if="scope.row.roleNameList">
	            <div v-for="(item, index) in scope.row.roleNameList" :key="index">
	              {{ item }}
	            </div>
	          </div>
	          <div v-else>--</div>
	        </template>
	      </el-table-column>
	      <el-table-column label="手机号" prop="phone" align="center">
	        <template slot-scope="scope">
	          {{ scope.row.phone ? scope.row.phone : "--" }}
	        </template>
	      </el-table-column>
	      <el-table-column label="邮箱" prop="email">
	        <template slot-scope="scope">
	          {{ scope.row.email ? scope.row.email : "--" }}
	        </template>
	      </el-table-column>
	    </el-table>
	    <div class="pagination-wrap">
	      <el-pagination background @size-change="adminSizeChange" @current-change="adminCurrentChange" :current-page.sync="adminPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="adminPage.pageSize"
	        layout="total, sizes, prev, pager, next, jumper" :total="adminPage.total">
	      </el-pagination>
	    </div>
	  </div>
	  <div class="submit-con" style="text-align:right;margin-top:20px;">
	    <el-button type="primary" size="small" @click="onConfirmAdminChoose">确认</el-button>
	  </div>
	</el-dialog>
	<!-- 选择客户 -->
	<el-dialog title="选择客户" :visible.sync="khListModal" width="1000px" class="yhg-dialog" @open="openKhSelectModal">
	  <div class="select-con single">
	    <span class="label">已选客户：</span>
	    <div class="content" v-if="selectKh">
	      <el-tag class="select-tag" closable :type="selectKh.companyName" effect="dark" @close="onKhTagClose">
	        <span class="select-tag-text">{{ selectKh.companyName }}</span>
	      </el-tag>
	    </div>
	  </div>
	  <div class="filter-con">
	    <span class="label">用户搜索：</span>
	    <el-input size="small" v-model="khForm.nameOrCode" placeholder="用户名/手机号" @keyup.enter.native="onKhSearch"></el-input>
	    <el-button class="search-btn" size="small" type="primary" @click="onKhSearch">搜索</el-button>
	  </div>
	  <div class="table-con">
	    <el-table :data="khTable" v-loading="khTableLoading" size="mini" ref="khSelectTable">
	      <el-table-column label="选择" width="55" align="center">
	        <template slot-scope="scope">
	          <span class="hide-label-radio">
	            <el-radio v-model="selectKhId" @change="onChangeKh" :label="scope.row.id"></el-radio>
	          </span>
	        </template>
	      </el-table-column>
	      <el-table-column label="客户名称" prop="companyName" align="center"></el-table-column>
	      <el-table-column label="手机号" prop="companyPhone" align="center">
	        <template slot-scope="scope">
	          {{ scope.row.companyPhone ? scope.row.companyPhone : "--" }}
	        </template>
	      </el-table-column>
	      <el-table-column label="公司地址" prop="companyAddress">
	        <template slot-scope="scope">
	          {{ scope.row.companyAddress ? scope.row.companyAddress : "--" }}
	        </template>
	      </el-table-column>
	    </el-table>
	    <div class="pagination-wrap">
	      <el-pagination background @size-change="khSizeChange" @current-change="khCurrentChange" :current-page.sync="khPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="khPage.pageSize"
	        layout="total, sizes, prev, pager, next, jumper" :total="khPage.total">
	      </el-pagination>
	    </div>
	  </div>
	  <div class="submit-con" style="text-align:right;margin-top:20px;">
	    <el-button type="primary" size="small" @click="onConfirmKhChoose">确认</el-button>
	  </div>
	</el-dialog>
	<!-- 关联商务合同 -->
	<el-dialog title="关联商务合同" :visible.sync="mediaListModal" width="1000px" class="yhg-dialog" @open="openMediaSelectModal">
	  <div class="select-con">
	    <span class="label">已关联商务合同：</span>
	    <div class="content">
	      <el-tag class="select-tag" v-for="item in selectMediaList" :key="item.mediaType + '-' + item.mediaId" closable :type="isMediaCloseType(item)" effect="dark"  @close="onMediaTagClose(item)">
	        <span class="select-tag-text">{{ item.name }}</span>
	      </el-tag>
	    </div>
	  </div>
	  <div class="filter-con">
	    <span class="label"></span>
	    <el-input size="small" style="margin-right: 10px;" clearable v-model="mediaForm.nameOrCode" placeholder="商务合同编号/名称" @keyup.enter.native="onMediaSearch"></el-input>
		<el-input size="small" style="margin-right: 10px;" clearable v-model="mediaForm.customerName" placeholder="客户名称" @keyup.enter.native="onMediaSearch"></el-input>
		<el-input size="small" clearable v-model="mediaForm.businessPrincipal" placeholder="业务负责人" @keyup.enter.native="onMediaSearch"></el-input>
	    <el-button class="search-btn" size="small" type="primary" @click="onMediaSearch">搜索</el-button>
	  </div>
	  <div class="table-con">
	    <el-table :data="mediaTable" v-loading="mediaTableLoading" size="mini" @select="onSingleSelect" @select-all="onAllSelect" :row-key="getRowKeys" ref="mediaSelectTable">
	      <el-table-column label="选择" type="selection" width="55" align="center" :reserve-selection="true" :selectable="checkboxT"></el-table-column>
	      <el-table-column label="商务合同名称" prop="name" align="center" min-width="80"></el-table-column>
		  <el-table-column label="客户名称" prop="customerName" align="center" min-width="80"></el-table-column>
		   <el-table-column label="业务负责人" prop="businessPrincipal" align="center" min-width="80"></el-table-column>
	      <el-table-column label="关联框架合同" prop="frameworkAgreementName" align="center" min-width="140"></el-table-column>
	    </el-table>
	    <div class="pagination-wrap">
	      <el-pagination background @size-change="mediaSizeChange" @current-change="mediaCurrentChange" :current-page.sync="mediaPage.pageNum" :page-sizes="[5,10, 20, 30, 40, 50, 100]" :page-size="mediaPage.pageSize"
	        layout="total, sizes, prev, pager, next, jumper" :total="mediaPage.total">
	      </el-pagination>
	    </div>
	  </div>
	  <div class="submit-con" style="display: flex;justify-content:space-between;margin-top: 20px;">
		  <div></div>
	    <el-button type="primary" size="small"  @click="onConfirmMediaChoose">确认</el-button>
	  </div>
	</el-dialog>
  </div>
</template>
<script>
import { addAgree,getKh,getHt,getXydetail,editAgree,getHz } from "../index.js";
import { listAdmin } from "@/api/business/contract";//有花果负责人
import sealPeople from "@/components/common/sealPeople";//引入选择盖章经办人
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
export default {
	components: {
		sealPeople
	},
  data() {
    return {
	  
	  //有花果协助负责人
	  accountName:'',
	  adminListModal: false,//有花果负责人
	  adminPage: {
	    pageSize: 10,
	    pageNum: 1,
	    total: 0,
	  },
	  adminForm: {
	    queryString: "",
	  },
	  selectAdminId: null,
	  selectAdmin: null,
	  adminTable: [],
	  adminTableLoading: false,
	  //客户选择
	  khListModal: false,//有花果负责人
	  khPage: {
	    pageSize: 10,
	    pageNum: 1,
	    total: 0,
	  },
	  khForm: {
	    nameOrCode: "",
	  },
	  selectKhId: null,
	  selectKh: null,
	  khTable: [],
	  khTableLoading: false,
	  //关联商务合同
	  contractName:'',//用来显示的名称
	  mediaListModal:false,
	  selectMediaList: [],
	  mediaForm: {
	    businessPrincipal: "",//业务负责人
		customerName:'',//客户名称
		nameOrCode:'',//合同名称
	  },
	  mediaTable: [],
	  mediaTableLoading: false,
	   disableMediaCheckbox: [],
	  mediaPage: {
	    pageSize: 5,
	    pageNum: 1,
	    total: 0,
	  },
	  
	  
	  fileList1:[],//上传补充协议附件
	  fileList2:[],//框架协议文件
	  fileList3:[],//框架协议扫描件
	  khType:[
		  {label:'品牌方',value:1},
		   {label:'Agency',value:2},
	  ],//客户类型
	  htType:[
		  {label:'洽谈中',value:1},
		   {label:'已签约',value:2},
	  ],//合同状态
      sealType:[
		  {label:'公章',value:1},
		   {label:'合同章',value:2},
	  ],//盖章类型
      sealStatus:[
		  {label:'待申请盖章',value:1},
		   {label:'盖章审核中',value:2},
		   {label:'盖章审核不通过',value:3},
		   {label:'待盖章',value:4},
		   {label:'已盖章',value:5},
		   {label:'已作废',value:6},
	  ],//盖章状态
	  pickerOptionsStart: {
	  			   disabledDate: time => {
	  					  if (this.ruleForm.endTime) {
	  						   return time.getTime() > new Date(this.endTime).getTime()
	  					 }
	  			  }
	   },
	   pickerOptionsEnd: {
	  				disabledDate: time => {
	  					  if (this.ruleForm.beginTime) {
	  							  return time.getTime() < new Date(this.ruleForm.beginTime).getTime() 
	  					  }
	  				 }
	   },
      ruleForm:{
		  "accountList": [
		  ],//涵盖博主账号
		  "auditStatus": null,//审批状态
		  "auditTime": "",//审批时间
		  "beginTime": "",//合同开始时间
		  "brandResource": "",//品牌资源
		  "contractIds": [
		  ],//关联商务合同ids
		  "contractName": [
			""
		  ],//关联商务合同名称
		  "count": null,//框架累计合作次数
		  "createTime": "",//创建时间
		  "createUserId": "",//创建人id
		  "createUserName": "",//创建人
		  "customerId": 0,//客户id
		  "customerName": "",//客户名称
		  "customerType": null,//客户类型
		  "endTime": "",//合同结束时间
		  "fileList": [

		  ],//协议附件列表
		  "id": null,//主键id
		  "money": null,//框架累计金额
		  "name": "",//框架协议名称
		  "paymentClause": "",//付款条款
		  "policy": "",//框架协议政策
		  "principalId": "",//有花果负责人id
		  "principalName": "",//有花果负责人名称
		  "sealApplyTime": "",//盖章申请时间
		  "sealApplyUserId": "",//盖章申请人id
		  "sealApplyUserName": "",//盖章申请人名称
		  "sealOperatorId": "",//盖章经办人id
		  "sealOperatorName": "",//盖章经办人名称
		  "sealStatus": null,//盖章状态
		  "sealTime": "",//盖章时间
		  "sealType": null,//盖章类型（1-公章；2-合同章）
		  "sealUserId": "",//盖章人id
		  "sealUserName": "",//盖章人Name
		  "status": null,//合同状态 1洽谈中 2已签约
		  "supplementalAgreementClause": "",//补充协议条款
		  "updateTime": "",//更新时间
		  "updateUserId": "",//更新人id
		  "updateUserName": "",//更新人
	  },//提交数据
      options: [{
        value: 1,
        label: '审批通过'
      }, {
        value: 0,
        label: '审批不通过'
      },],
	  rlList:[
	  		  {label:'未认领',value:1},
	  		  {label:'部分认领',value:2},
	  		  {label:'完全认领',value:3},
	  ],//认领状态1未认领 2部分认领 3完全认领
      rules: {
		name: [
		  { required: true, message: '请输入框架协议名称', trigger: 'change' }
		],
		customerName: [
		  { required: true, message: '请输入客户名称', trigger: 'change' }
		],
		customerType: [
		  { required: true, message: '请选择客户类型', trigger: 'change' }
		],
		status: [
		  { required: true, message: '请选择合同状态', trigger: 'change' }
		],
		principalName: [
		  { required: true, message: '请选择有花果对接负责人', trigger: 'change' }
		],
      },
	  rules2: {
		name: [
		  { required: true, message: '请输入框架协议名称', trigger: 'change' }
		],
		customerName: [
		  { required: true, message: '请输入客户名称', trigger: 'change' }
		],
		customerType: [
		  { required: true, message: '请选择客户类型', trigger: 'change' }
		],
		status: [
		  { required: true, message: '请选择合同状态', trigger: 'change' }
		],
		principalName: [
		  { required: true, message: '请选择有花果对接负责人', trigger: 'change' }
		],
		beginTime: [
		  { required: true, message: '请选择合同开始时间', trigger: 'change' }
		],
		endTime: [
		  { required: true, message: '请选择合同结束时间', trigger: 'change' }
		],
		policy: [
		  { required: true, message: '请输入框架协议政策', trigger: 'change' }
		],
		paymentClause: [
		  { required: true, message: '请输入付款条款', trigger: 'change' }
		],
		sealType: [
		  { required: true, message: '请选择盖章类型', trigger: 'change' }
		],
		sealOperatorName: [
		  { required: true, message: '请选择盖章经办人', trigger: 'change' }
		],
	  },
      parmFrom:{
        id:this.$route.query.id,
        isPass:"",
        notPassReason:"",
        auditRemark:"",
      },
    };
  },
	computed:{
		// 动态切换验证规则
		dynamicRules() {
			return this.ruleForm.status ===  1 ? this.rules: this.rules2;
		}
	},
  mounted() {
	console.log(this.$route.query.id)
	if(this.$route.query.id){
			  this.getDetail()
	}
    // this.detailsInit()
  },
  methods: {
	  // 查询合同详情
	  getDetail(){
		  var obj = {
			  id : this.$route.query.id
		  }
		 getXydetail(obj)
		    .then((res) => {
		  		console.log('我是详情',res)
				this.ruleForm = res.data
				//回显文件
				this.ruleForm.fileList.forEach((e)=>{
					 if(e.fileType==1){this.fileList1.push(e)}
					 else if(e.fileType==2){this.fileList2.push(e)}
					 else if(e.fileType==3){this.fileList3.push(e)}
				})
				//回显涵盖博主
				var bzname="";//空的字符串
				 this.ruleForm.accountList.forEach((e)=>{
					  console.log(e)
					 bzname+=e+','
				 })
				 console.log(this.ruleForm.accountList)
				this.accountName = bzname
				//回显选中合同
				
				 this.selectMediaList = this.ruleForm.contractList
				 console.log(this.ruleForm.contractList)
				 console.log(this.ruleForm.contractList)
				 var name="";//空的字符串
				 this.ruleForm.contractList.forEach((e)=>{
					 name+=e.name+','
				 })
				this.contractName = name

				 console.log(1111)
				 this.$forceUpdate()
				 //回显客户名称
				 this.selectKhId = this.ruleForm.customerId
				 const str= {
					 id:this.ruleForm.customerId,
					 companyName:this.ruleForm.customerName
				 }
				  this.selectKh = str
				 //回显对接人
				 this.selectAdminId = this.ruleForm.principalId
				 const str2= {
					 id:this.ruleForm.principalId,
					 username:this.ruleForm.principalName
				 }
				 this.selectAdmin = str2
				 // this.selectAdmin.username = this.ruleForm.principalName

				 // selectMediaList  contractList
				
				
				 this.$forceUpdate()
		    })
		    .catch((err) => {
		  	
		    });
	  },
//关联商务合同
    /** 全选 */
    onAllSelect(val) {
		console.log(val)
		let other = [], //其他页数据
		  current = []; //本页数据
		this.selectMediaList.forEach((v) => {
		  if (
		    this.mediaTable.findIndex(
		      (v1) => v1.id == v.id
		    ) === -1
		  ) {
		    other.push(v);
		  } else {
		    current.push(v);
		  }
		});
		let mediaPageValid = this.mediaTable.filter(
		  (v) =>
		    this.disableMediaCheckbox.findIndex(
		      (v1) => v1.id == v.id
		    ) === -1
		);
		let mediaPageUnval = this.mediaTable.filter(
		  (v) =>
		    this.disableMediaCheckbox.findIndex(
		      (v1) => v1.id == v.id
		    ) !== -1
		);
		let nonSelectArr = mediaPageValid.filter(
		  (v) =>
		    this.selectMediaList.findIndex(
		      (v1) =>v1.id == v.id
		    ) === -1
		);
		if (nonSelectArr.length > 0) {
		  this.mediaTable.forEach((v) => {
		    let index = this.selectMediaList.findIndex(
		      (v2) => v2.id == v.id
		    );
		    if (index === -1) {
		      this.selectMediaList.push(v);
		    }
		  });
		} else {
		  this.selectMediaList = [...other, ...mediaPageUnval];
		}
    },
    //资源弹窗关闭
    onConfirmMediaChoose() {
      this.mediaListModal = false;
	  console.log('选中',this.selectMediaList)

	  var ids = [];
	  var names = [];
	  this.selectMediaList.forEach((e)=>{
		  ids.push(e.id)
		  names.push(e.name)
	  })
	  console.log(ids,names)
	  if(ids.length==0){
	  		  this.ruleForm.money = ''
	  		  this.ruleForm.count = ''
	  		  this.accountName = ''
	  }
	  this.ruleForm.contractIds = ids
	  this.ruleForm.contractName = names
	  this.contractName = this.ruleForm.contractName.toString();
	  
	  // 此处要动态获取合作信息
	  const obj = {
		  ids : ids
	  }
	  if(ids.length == 0){
		 this.$message({
		   message: '请先选中合同',
		   type: 'warning'
		 });
		 return
	  }
	 getHz(obj)
	    .then((res) => {
	      console.log(res)
		  this.ruleForm.money = res.data.money
		  this.ruleForm.count = res.data.count
		  // 回显涵盖博主
		  var bzname="";//空的字符串
		  res.data.bloggerName.forEach((e)=>{
		  	  console.log(e)
		  	 bzname+=e+';'
		   })
		  this.accountName = bzname
		  console.log( this.accountName)
		  this.$forceUpdate()
	    })
	    .catch((err) => {
			
	    });
    },
	//复选框禁用
	checkboxT(row, rowIndex) {
      let isChecked = true;
      if (row.frameworkAgreementId === null) { // 判断里面是否存在某个参数
        isChecked = true
      } else {
         isChecked = false
      }
	   return isChecked
	},
	// * @param val 当前值
	//  * @param row 被选中/取消选中的对象
	//  */
	onSingleSelect(val, row) {
	    let index = this.selectMediaList.findIndex(
	      (v) => v.id == row.id
	    );
	    if (index === -1) {
	      this.selectMediaList.push(row);
	    } else {
	      this.selectMediaList.splice(index, 1);
	    }
	},
     // * 获取表格行id
     // * @param row
     // */
    getRowKeys(row) {
      return row.mediaId + "_" + row.mediaType;
    },
    //资源选择弹窗打开
    openMediaSelectModal() {
      this.mediaForm.queryString = "";
      this.onMediaSearch();
    },
	/**
	 * 资源标签删除
	 * @param item 标签元素
	 */
	onMediaTagClose(item) {
	  let index = this.selectMediaList.findIndex(
	    (v) => v.id == item.id
	  );
	  let tbItem = this.mediaTable.find(
	    (v) => v.id == item.id
	  );
	  if (index !== -1) {
	    this.selectMediaList.splice(index, 1);
	    this.$refs.mediaSelectTable.toggleRowSelection(tbItem, false);
	    this.$forceUpdate();
	  }
	},
	/**
	 * 资源标签类型
	 * @param item 标签元素
	 */
	isMediaCloseType(item) {
	  if (
	    this.operateType === "edit" &&
	    this.disableMediaCheckbox.find(
	      (v) => v.mediaType == item.mediaType && v.mediaId == item.mediaId
	    )
	  ) {
	    return "info"; //禁用
	  } else {
	    return "primary";
	  }
	},
	/**
	 * 监听分页器每页显示的条数变化
	 * @param val 条数
	 */
	mediaSizeChange(val) {
	  this.mediaPage.pageNum = 1;
	  this.mediaPage.pageSize = val;
	  this.getMediaList();
	},
	/**
	 * 监听页数变化
	 * @param val 当前页数
	 */
	mediaCurrentChange(val) {
	  this.mediaPage.pageNum = val;
	  this.getMediaList();
	},
	//资源搜索
	onMediaSearch() {
	  this.mediaPage.pageNum = 1;
	  this.getMediaList();
	},
	//获取资源列表
	getMediaList() {
	  let obj = {
	    pageSize: this.mediaPage.pageSize,
	    pageNum: this.mediaPage.pageNum,
		businessPrincipal:this.mediaForm.businessPrincipal,
		customerName:this.mediaForm.customerName,
		nameOrCode:this.mediaForm.nameOrCode,
	  };
	  this.mediaTableLoading = true;
	  getHt(obj)
	    .then((res) => {
			console.log('我是合同',res)
	      this.mediaTable = res.data || [];
	      this.mediaPage.total = res.total;
	      this.mediaTableLoading = false;
		  this.$nextTick(() => {
		    this.mediaTable.forEach((item) => {
		      let selected =
		        this.selectMediaList.findIndex(
		          (v) =>
		            v.id == item.id
		        ) !== -1;
		      this.$refs.mediaSelectTable.toggleRowSelection(item, selected);
		    });
		  });
	    })
	    .catch((err) => {
	      this.mediaTable = [];
	      this.mediaPage.total = 0;
	      this.mediaTableLoading = false;
	    });
	},
// 有花果负责人
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      // this.ruleForm.selectAdmin = this.selectAdmin;
      this.adminListModal = false;
	  // this.$emit('select',this.selectAdmin)
	  // console.log(this.selectAdmin)
	  this.ruleForm.principalName = this.selectAdmin.username
	  this.ruleForm.principalId = this.selectAdmin.id
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    adminSizeChange(val) {
      this.adminPage.pageNum = 1;
      this.adminPage.pageSize = val;
      this.getAdminList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    adminCurrentChange(val) {
      this.adminPage.pageNum = val;
      this.getAdminList();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
	  console.log(this.selectAdmin)
    },
//选择客户
	    //资源选择弹窗打开
	    openKhSelectModal() {
	      this.onKhSearch();
	    },
	    //资源标签删除
	    onKhTagClose() {
	      this.selectKh = null;
	      this.selectKhId = null;
	    },
	    //资源弹窗关闭
	    onConfirmKhChoose() {
	      // this.ruleForm.selectAdmin = this.selectAdmin;
	      this.khListModal = false;
		  // this.$emit('select',this.selectAdmin)
		  // console.log(this.selectAdmin)
		  console.log(this.selectKh)
		  this.ruleForm.customerName = this.selectKh.companyName
		  this.ruleForm.customerId = this.selectKh.id
	    },
	    /**
	     * 监听分页器每页显示的条数变化
	     * @param val 条数
	     */
	    khSizeChange(val) {
	      this.khPage.pageNum = 1;
	      this.khPage.pageSize = val;
	      this.getKhList();
	    },
	    /**
	     * 监听页数变化
	     * @param val 当前页数
	     */
	    khCurrentChange(val) {
	      this.khPage.pageNum = val;
	      this.getKhList();
	    },
	    //资源搜索
	    onKhSearch() {
	      this.khPage.pageNum = 1;
	      this.getKhList();
	    },
	    //获取资源列表
	    getKhList() {
	      let obj = {
	        pageSize: this.khPage.pageSize,
	        pageNum: this.khPage.pageNum,
	      };
	      if (this.khForm.nameOrCode && this.khForm.nameOrCode.trim()) {
	        obj.nameOrCode = this.khForm.nameOrCode.trim();
	      }
	      this.khTableLoading = true;
	      getKh(obj)
	        .then((res) => {
	          this.khTable = res.data || [];
	          this.khPage.total = res.total;
	          this.khTableLoading = false;
	        })
	        .catch((err) => {
	          this.khTable = [];
	          this.khPage.total = 0;
	          this.khTableLoading = false;
	        });
	    },
	    //资源选择变化
	    onChangeKh(val) {
	      this.selectKh = this.khTable.find((v) => v.id == val);
	    },
	
	
	
	
	//选择盖章经办人
	  selectPeople(row){
	  		  console.log(row)
			  this.ruleForm.sealOperatorName = row.username
			  this.ruleForm.sealOperatorId = row.id
	  },
	//点击上传文件预览
	handlePreview(file){
	        console.log(file);
			this.downloadFile(file.url,file.name)
	},
	//点击移除文件(补充协议附件)
	  handleRemove1(file, fileList) {
		console.log(file, fileList);
		this.fileList1 = fileList
	  },
	  //点击移除文件(框架协议文件)
	    handleRemove2(file, fileList) {
	  	console.log(file, fileList);
	  	this.fileList2 = fileList
	    },
	  //点击移除文件(框架协议扫描件)
	    handleRemove3(file, fileList) {
	  	console.log(file, fileList);
	  	this.fileList3 = fileList
	    },
    //保存
    saveClick(formName){
		
		
		// 如果合同状态为洽谈中,框架协议文件必填
		this.ruleForm.fileList = [];
		this.fileList1.forEach((e)=>{
			this.ruleForm.fileList.push(e)
		})
		this.fileList2.forEach((e)=>{
			this.ruleForm.fileList.push(e)
		})
		this.fileList3.forEach((e)=>{
			this.ruleForm.fileList.push(e)
		})
		this.$refs[formName].validate((valid) => {
		  if (valid) {
			  if(this.ruleForm.status==2 && this.fileList2.length==0){
			  	this.$message({
			  	  message: '框架协议文件必须上传',
			  	  type: 'warning'
			  	});
			  	return
			  };
				 if(this.$route.query.id){
					 editAgree(this.ruleForm)
					   .then((res) => {
					 		 this.$message.success("修改成功！");
							 setTimeout(() => {
							   this.$router.push({ path: `/business/frameAccord` });
							 }, 500)
					   })
					   .catch((err) => {
					 	
					   });
				 }else{
					 addAgree(this.ruleForm)
					   .then((res) => {
					 		 this.$message.success("创建成功！");
							 this.$parent.activeIndex = 'list';
					   })
					   .catch((err) => {
					 	
					   });
				 }
				
		  } else {
			return false;
		  }
		});
		console.log(this.ruleForm)
      // addAgree(this.parmFrom).then(res=>{
      //   if(res.code === 1){
      //     this.$message.success(`审批成功!`);
      //     this.submitLoading = false;
      //     setTimeout(() => {
      //       this.$router.push({ path: `/check/sealApproval` });
      //     }, 500)
      //   }
      // })
    },
    detailsInit(){
      approvalDetail({id:this.$route.query.id}).then(res=>{
        this.ruleForm = res.data
        console.log('=======详情======',res)
      })
    },
    //上传补充协议附件上传
    beforeUpload(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          observable.subscribe({
            next(res) {
              console.log("upload...", res);
            },
            error(error) {
              this.$message.error("上传失败");
              console.log("error", error);
            },
            complete: (complete) => {
              console.log("complete");
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.$set(this.ruleForm, "fileName", file.name);
              this.$set(this.ruleForm, "path", qiniuBaseUrl + complete.key);
			  const str  ={
				  name:file.name,
				  url:qiniuBaseUrl + complete.key,
				  fileType:1,
				  path:qiniuBaseUrl + complete.key,
			  }
			  this.fileList1.push(str)
			  console.log(this.fileList1)
            },
          });
        })
        .catch((error) => {});
      return false;
    },
	//上传框架协议文件
	beforeUpload2(file) {
	  if (file.size > 500 * 1024 * 1024) {
	    this.$message.error("文件大小不能超过500M");
	    return false;
	  }
	  qiniuToken()
	    .then((res) => {
	      let that = this;
	      let fileName = Date.now() + file.name;
	      var observable = qiniu.upload(file, fileName, res.data);
	      observable.subscribe({
	        next(res) {
	          console.log("upload...", res);
	        },
	        error(error) {
	          this.$message.error("上传失败");
	          console.log("error", error);
	        },
	        complete: (complete) => {
	          console.log("complete");
	          let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
	          this.$set(this.ruleForm, "fileName", file.name);
	          this.$set(this.ruleForm, "path", qiniuBaseUrl + complete.key);
			  const str  ={
				  name:file.name,
				  url:qiniuBaseUrl + complete.key,
				  fileType:2,
				  path:qiniuBaseUrl + complete.key,
			  }
			  this.fileList2.push(str)
			  console.log(this.fileList2)
	        },
	      });
	    })
	    .catch((error) => {});
	  return false;
	},
	//上传框架协议扫描件
	beforeUpload3(file) {
	  if (file.size > 500 * 1024 * 1024) {
	    this.$message.error("文件大小不能超过500M");
	    return false;
	  }
	  qiniuToken()
	    .then((res) => {
	      let that = this;
	      let fileName = Date.now() + file.name;
	      var observable = qiniu.upload(file, fileName, res.data);
	      observable.subscribe({
	        next(res) {
	          console.log("upload...", res);
	        },
	        error(error) {
	          this.$message.error("上传失败");
	          console.log("error", error);
	        },
	        complete: (complete) => {
	          console.log("complete");
	          let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
	          this.$set(this.ruleForm, "fileName", file.name);
	          this.$set(this.ruleForm, "path", qiniuBaseUrl + complete.key);
			  const str  ={
				  name:file.name,
				  url:qiniuBaseUrl + complete.key,
				  fileType:3,
				  path:qiniuBaseUrl + complete.key,
			  }
			  this.fileList3.push(str)
			  console.log(this.fileList3)
	        },
	      });
	    })
	    .catch((error) => {});
	  return false;
	},
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input-group__append {
  position: relative;
  width: 28px;
  height: 28px;
  border: none;
  background: #fff;
  padding: 0;
  color: #409eff !important;
  .iconfont {
	position: absolute;
	top: 0;
	left: 0;
	  right: 0;
	  bottom: 0;
	  margin: auto;
	font-size: 28px !important;
	   color: #409eff !important;
	   margin: 0 auto !important;
	   text-align: center !important;
  }
  cursor: pointer;
}
.title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 30px;
}
.block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
 .select-input-wrap-s {
   .el-input-group__append {
     position: relative;
     width: 35px;
     height: 35px;
     border: none;
     background: #fff;
     padding: 0;
     color: #409eff;
     .iconfont {
       position: absolute;
       font-size: 36px !important;
     }
     cursor: pointer;
   }
 }
 .yhg-dialog {
   .select-con {
     display: flex;
     .label {
       white-space: nowrap;
     }
     .select-tag {
       margin-right: 5px;
       margin-bottom: 5px;
     }
     .select-tag-text {
       display: inline-block;
       max-width: 86px;
       overflow: hidden;
       text-overflow: ellipsis;
     }
   }
 }
 .filter-con {
     display: flex;
     align-items: center;
     margin: 20px 0;
     width: 800px;
     .label {
       white-space: nowrap;
     }
     .search-btn {
       margin-left: 15px;
     }
 }
</style>
